/**
 * AI Service Configuration
 */

/**
 * Supported AI models
 */
export enum AIModel {
  GEMINI = "gemini-1.5-flash",
}

/**
 * AI Service Configuration
 */
export interface AIServiceConfig {
  /**
   * The default model to use
   */
  defaultModel: AIModel;

  /**
   * The confidence threshold for AI results
   * Results with confidence below this threshold will trigger fallback to pattern matching
   */
  confidenceThreshold: number;

  /**
   * Maximum tokens to generate
   */
  maxTokens: number;

  /**
   * Temperature for generation (0.0 - 1.0)
   * Lower values make output more deterministic
   */
  temperature: number;

  /**
   * Top-k for generation
   */
  topK: number;

  /**
   * Top-p for generation
   */
  topP: number;
}

/**
 * Default AI service configuration
 */
const DEFAULT_CONFIG: AIServiceConfig = {
  defaultModel: AIModel.GEMINI,
  confidenceThreshold: 0.3,
  maxTokens: 1024,
  temperature: 0.4,
  topK: 40,
  topP: 0.95,
};

/**
 * Gets the AI service configuration
 * @returns The AI service configuration
 */
export function getAIServiceConfig(): AIServiceConfig {
  return DEFAULT_CONFIG;
}
